import { DatePicker } from '@mui/x-date-pickers'
import { IconCalendar } from 'icons'
import moment from 'moment/moment'

const SingleDatePicker = ({
  outlined,
  disableNav,
  value,
  allowEmpty,
  slots = {},
  ...props
}) => {
  return (
    <DatePicker
      className="date-picker"
      {...props}
      value={allowEmpty && !value ? undefined : moment(value)}
      slotProps={{
        textField: {
          variant: outlined ? undefined : 'filled',
          // error: allowEmpty && !value ? false : undefined,
          error: !value?.length ? false : undefined,
        },
        openPickerButton: {
          edge: false,
        },
      }}
      slots={{
        openPickerIcon: IconCalendar,
        ...slots
      }}
    />
  )
}

export default SingleDatePicker
